import * as React from "react";

const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

export default ColorModeContext;
